<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} width={155} height={28} viewBox="0 0 155 28">
	<path
		d="M32.3913 8.98774V6.08028H23.1208V21.5001H32.4999V18.5922H26.1097V15.1336H31.8502V12.27H26.1097V8.98774H32.3913Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M2.98925 12.2041V6.08008H0V21.4999H2.98925V15.1119H8.62109V21.4999H11.5888V6.08008H8.62109V12.2041H2.98925Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M52.013 15.4864L45.5145 6.08008H43.2401V21.4999H46.2294V12.0721L52.7279 21.4999H55.0022V6.08008H52.013V15.4864Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M69.39 21.4999V6.08008H66.4012V21.4999H69.39Z" fill={getTailwindColor(color)} />
	<path
		d="M84.3806 16.924H86.1626C86.1626 17.826 86.5146 18.596 87.1966 19.212C87.8786 19.828 88.8026 20.136 89.9466 20.136C91.9926 20.136 93.4226 19.124 93.4226 17.54C93.4226 12.7 84.9086 16.088 84.9086 9.928C84.9086 8.784 85.3486 7.816 86.2506 7.024C87.1526 6.21 88.3406 5.814 89.8366 5.814C92.1466 5.814 94.8966 7.112 94.8966 10.28H93.0706C93.0706 8.52 91.9046 7.442 89.8146 7.442C87.7686 7.442 86.6906 8.542 86.6906 9.928C86.6906 14.13 95.2266 11.204 95.2266 17.43C95.2266 18.684 94.7426 19.718 93.7746 20.554C92.8066 21.368 91.5086 21.786 89.8806 21.786C86.8666 21.874 84.3366 19.718 84.3806 16.924ZM103.716 21.5H101.934V6.1H103.716V12.854H111.9V6.1H113.682V21.5H111.9V14.482H103.716V21.5ZM120.4 13.8C120.4 9.268 123.788 5.814 128.364 5.814C132.962 5.814 136.328 9.29 136.328 13.8C136.328 18.332 132.962 21.786 128.342 21.786C123.766 21.786 120.4 18.354 120.4 13.8ZM122.248 13.8C122.248 17.452 124.866 20.114 128.364 20.114C130.124 20.114 131.576 19.52 132.742 18.332C133.908 17.122 134.48 15.626 134.48 13.8C134.48 10.214 131.862 7.486 128.364 7.486C124.866 7.486 122.248 10.214 122.248 13.8ZM144.825 21.5H143.043V6.1H148.565C149.973 6.1 151.117 6.518 151.975 7.376C152.833 8.212 153.273 9.334 153.273 10.72C153.273 12.106 152.833 13.228 151.931 14.108C151.051 14.966 149.929 15.406 148.565 15.406H144.825V21.5ZM144.825 7.684V13.822H148.411C150.237 13.822 151.447 12.502 151.447 10.72C151.447 8.938 150.259 7.684 148.411 7.684H144.825Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
